module.exports = __webpack_public_path__ + "static/media/animal-06.25e7d3be.mp3";